import {
  Heart,
  Stethoscope,
  Smile,
  Shield,
  Activity,
  Clock,
  Sparkles,
  Award,
  Calendar,
  Phone,
  Skull,
  Baby
} from 'lucide-react';

export const hospitalInfo = {
  name: "Dr. Ajinkya's Dento Care",
  tagline: "An Advanced Dental Clinic",
  subtitle: "Leading Dental Clinic in Jaysingpur",
  description: "A state-of-the-art dental clinic providing comprehensive oral health care services with advanced technology and compassionate care. Dr. Ajinkya is a renowned dental surgeon committed to providing the highest quality dental care with modern techniques and personalized attention.",
  emergency: "+919922322311",
  email: "drajinkyadentocare@gmail.com",
  phone: "+919922322311",
  address: "1st floor, Kolhapur - Sangli Hwy, above Med Plus, opposite to Post Office, Purtiwadi, Jaysingpur, Maharashtra - 416101",
  workingHours: "10:00 AM - 8:00 PM (Monday - Sunday)",
  established: "2025",
  calLink: "ajinkya-patil/60min"
};

export const specialities = [
  {
    id: 1,
    name: "General Dentistry",
    icon: "Stethoscope",
    description: "Comprehensive oral health care including cleanings, fillings, and preventive care.",
    conditions: ["Regular Checkups", "Teeth Cleaning", "Fillings", "Root Canal Treatment"]
  },
  {
    id: 2,
    name: "Cosmetic Dentistry",
    icon: "Smile",
    description: "Transform your smile with our advanced cosmetic dental procedures.",
    conditions: ["Teeth Whitening", "Veneers", "Dental Bonding", "Smile Makeover"]
  },
  {
    id: 3,
    name: "Dental Implants",
    icon: "Shield",
    description: "Permanent solution for missing teeth with state-of-the-art implant technology.",
    conditions: ["Single Implants", "Multiple Implants", "Full Mouth Restoration", "Immediate Implants"]
  },
  {

    id: 4,
    name: "Orthodontics",
    icon: "Activity",
    description: "Straighten your teeth with modern braces and aligner systems.",
    conditions: ["Metal Braces", "Ceramic Braces", "Invisalign", "Retainers"]
  },
  {
    id: 5,
    name: "Oral Surgery",
    icon: "Skull",
    description: "Expert surgical procedures for complex dental issues.",
    conditions: ["Tooth Extraction", "Wisdom Teeth Removal", "Gum Surgery", "Jaw Surgery"]
  },
  {
    id: 6,
    name: "Pediatric Dentistry",
    icon: "Baby",
    description: "Specialized dental care for children in a friendly, comfortable environment.",
    conditions: ["Child-Friendly Care", "Preventive Treatment", "Early Orthodontics", "Sedation Options"]
  }
];

export const services = [
  {
    "id": 1,
    "name": "General Dentistry",
    "description": "Comprehensive oral health care including cleanings, fillings, and preventive care.",
    "icon": "tooth",
    "features": ["Regular Checkups", "Teeth Cleaning", "Fillings", "Root Canal Treatment"]
  },
  {
    "id": 2,
    "name": "Cosmetic Dentistry",
    "description": "Transform your smile with our advanced cosmetic dental procedures.",
    "icon": "star",
    "features": ["Teeth Whitening", "Veneers", "Dental Bonding", "Smile Makeover"]
  },
  {
    "id": 3,
    "name": "Dental Implants",
    "description": "Permanent solution for missing teeth with state-of-the-art implant technology.",
    "icon": "medical",
    "features": ["Single Implants", "Multiple Implants", "Full Mouth Restoration", "Immediate Implants"]
  },
  {
    "id": 4,
    "name": "Orthodontics",
    "description": "Straighten your teeth with modern braces and aligner systems.",
    "icon": "straighten",
    "features": ["Metal Braces", "Ceramic Braces", "Invisalign", "Retainers"]
  },
  {
    "id": 5,
    "name": "Oral Surgery",
    "description": "Expert surgical procedures for complex dental issues.",
    "icon": "healing",
    "features": ["Tooth Extraction", "Wisdom Teeth Removal", "Gum Surgery", "Jaw Surgery"]
  },
  {
    "id": 6,
    "name": "Pediatric Dentistry",
    "description": "Specialized dental care for children in a friendly, comfortable environment.",
    "icon": "child_care",
    "features": ["Child-Friendly Care", "Preventive Treatment", "Early Orthodontics", "Sedation Options"]
  }
];

export const doctors = [
  {
    id: 1,
    name: "Dr. Ajinkya Patil",
    speciality: "Advanced Dental Care",
    qualifications: "BDS",
    experience: "2+ Years",
    image: "/images/doctors/doctor_photo.jpg",
    certifications: [
      "BDS - Bachelor of Dental Surgery",
      "Cosmetic Dentistry Specialist"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    comment: "Excellent service! Dr. Ajinkya is very professional and the clinic has modern equipment. Highly recommended!",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    comment: "Best dental experience I've ever had. The staff is friendly and the treatment was painless. Thank you!",
    date: "2024-02-20"
  },
  {
    id: 3,
    name: "Amit Patel",
    rating: 5,
    comment: "Got my dental implants done here. The entire process was smooth and the results are amazing!",
    date: "2024-03-10"
  },
  {
    id: 4,
    name: "Sneha Desai",
    rating: 5,
    comment: "My kids love coming here! The pediatric dental care is outstanding and the clinic is so welcoming.",
    date: "2024-04-05"
  },
  {
    id: 5,
    name: "Vikram Shah",
    rating: 5,
    comment: "Very clean and hygienic clinic. Dr. Ajinkya explains everything in detail. Great experience.",
    date: "2024-05-12"
  },
  {
    id: 6,
    name: "Anjali Gupta",
    rating: 5,
    comment: "The root canal treatment was completely painless. I was so nervous but they made me feel very comfortable.",
    date: "2024-06-18"
  },
  {
    id: 7,
    name: "Karan Malhotra",
    rating: 5,
    comment: "High quality dental care at reasonable prices. The best dental clinic in Jaysingpur.",
    date: "2024-07-22"
  },
  {
    id: 8,
    name: "Meera Reddy",
    rating: 5,
    comment: "Dr. Ajinkya's expertise in cosmetic dentistry is unmatched. I love my new smile!",
    date: "2024-08-30"
  },
  {
    id: 9,
    name: "Sanjay Joshi",
    rating: 5,
    comment: "Wonderful staff and state-of-the-art facilities. Truly an advanced dental clinic.",
    date: "2024-09-14"
  }
];

export const stats = [
  { label: "Successful Implants", value: "2000+", icon: "Shield" },
  { label: "Happy Smiles", value: "5000+", icon: "Smile" },
  { label: "Awards Won", value: "15+", icon: "Award" },
  { label: "Years of Trust", value: "10+", icon: "Clock" }
];

export const gallery = [
  { id: 1, image: "/images/gallery/gallery_1.jpg", title: "Modern Treatment Room" },
  { id: 2, image: "/images/gallery/gallery_2.jpg", title: "Diagnostic Center" },
  { id: 3, image: "/images/gallery/gallery_3.jpg", title: "Comfortable Waiting Area" },
  { id: 4, image: "/images/gallery/gallery_4.jpg", title: "Sterilization Unit" }
];

export const hospitalData = {
  ...hospitalInfo,
  specialities,
  services,
  doctors,
  testimonials,
  stats,
  gallery
};
